export default "__VITE_ASSET__20aa4849__"